import ModelTrainingIcon from "@mui/icons-material/ModelTraining";
import ListInternships from "./List";
import { AdministrationServicePath, INTERNSHIPS } from "utils/constants";
import EditInternships from "./Edit";
import CreateInternships from "./Create";
import permissions from "app/permissions";

//permissions
export const resources = {
  isMenu: true,
  recordRepresentation: "nameBg",
  icon: <ModelTrainingIcon />,
  name: AdministrationServicePath + INTERNSHIPS,
  title: "Стажове",
  list: <ListInternships />,
  create: <CreateInternships />,
  createPermission: permissions.canCreateInternships,
  edit: <EditInternships />,
  editPermission: permissions.canUpdateInternships,
  permission: permissions.canPreviewInternships,
};
